import { useEffect, useState } from "react";

/** Debounce delay for every search-as-you-type input (hybrid search, pickers):
 * one env-configurable value (REACT_APP_SEARCH_DEBOUNCE_MS, runtime env first). */
export const SEARCH_DEBOUNCE_MS =
  Number((window._env_ && window._env_.REACT_APP_SEARCH_DEBOUNCE_MS) ||
    process.env.REACT_APP_SEARCH_DEBOUNCE_MS) || 300;

/** `value`, but only after it has stopped changing for `delayMs`. */
export default function useDebouncedValue(value, delayMs = SEARCH_DEBOUNCE_MS) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);
  return debounced;
}
